import './license.css';

function License() {
  return (
    <div className="License">
        <p onClick={()=>{window.open('https://beian.miit.gov.cn', '_blank')}}>
            粤ICP备2021163188号-1
        </p>
    </div>
  );
}

export default License;
